























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {CallDetailInfoItem} from "@/store/call/statistic/types";
import {colorClassByStatus, formatAsJson} from "@/utils/page-utils";
import {notifyError, notifySuccess} from "@/utils/notify-helper";
import {dateFilter} from "@/utils/date-util";
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";
import {InputWings, TextareaWings} from "wings-ui-components";
import CallEventsDetail from "@/components/Call/Statistic/CallEventsDetail.vue";

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({
  components: {CallEventsDetail, InputWings, TextareaWings},
  filters: {dateFilter},
  methods: {colorClassByStatus, formatAsJson}
})
export default class CallDetailInfo extends Vue {
  @Action("getCallStatisticDetailInfo") actionGetCallStatisticDetailInfo: any;
  @Action("resendCallMessage") actionResend: any;
  @Action("actionLog") actionLog: any;
  @Action("getCallDetailEvents") actionGetCallDetailEvents: any;

  defaultInfo(): CallDetailInfoItem {
    return {
      create_date: "",
      id: "",
      originator: "",
      status: "",
      operator: "",
      message_type: "",
      ext_id1: "",
      ext_id2: "",
      ext_id3: "",
      ext_id4: "",
      ext_id5: "",
      connection_type: "",
      country: "",
      partner_price: 0,
      content: "",
      duration: "",
      broker_account_login: "",
      recipient: "",
      partner_user_login: "",
      message_direction: "",
      partner: "",
      template_id: 0,
      message: "",
      region: "",
      start_date: "",
      end_date: "",
      external_id: "",
      ring_duration: "",
      mcc: "",
      mnc: "",
      provider_price: 0,
      parent_message_id: 0,
      parent_message_transport: "",
      priority: "",
      bulk_id: "",
      error_code: 0,
      error_description: "",
      module: "",
      provider_message_id: "",
      provider_protocol: "",
      service_provider: "",
    };
  }

  private messageInfo: CallDetailInfoItem = this.defaultInfo();
  private transport = MsgTransports.CALL
  private logObject: ActionLog = {};

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Message",
          addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
        }
        await this.actionGetCallStatisticDetailInfo(this.$route.params.id).then((data: any) => {
          this.messageInfo = Object.assign({}, this.messageInfo, data);
        });
        await this.actionLog(this.logObject);
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  back(): void {
    this.$router.push('/call/detail/');
  }

  get isShowFinanceInfo(): boolean {
    let value: string = localStorage.getItem("show-finance-info") || "true";
    return JSON.parse(value);
  }

  async resend(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Resending",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      const data = {message_ids: [this.$route.params.id]}
      await this.resendFunction(data);
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err)
    }
  }

  async resendFunction(data: any) {
    const resp = await this.actionResend(data);
    if (resp.data.status === 'Success') {
      notifySuccess(this.$t('dialog.resend').toString());
      await this.actionGetCallDetailEvents({ id: this.$route.params.id });
    } else {
      notifyError();
    }
  }
}
